export default __webpack_public_path__ + "static/media/investingbooks.1e576db4.png";